import { Button, Input, message, Space, Table } from "antd";
import React, { useEffect, useState } from "react";
import configurationManagementService from "@services/configuationManagement.service";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import CreateAlert from "./components/Create";
import DeleteAlert from "./components/Delete";
import UpdateAlert from "./components/Update";

const Alert = () => {
  const [dataSet, setDataSet] = useState([]);
  const [filtredDataSet, setFiltredDataSet] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState({
    searchText: "",
    searchedColumn: "",
  });

  async function fetcher() {
    setLoading(true);
    try {
      const { data } = await configurationManagementService.fetchAlertList();
      setDataSet(data);
      setFiltredDataSet(data);

      let tmpColumns = [];
      const { _id, read, __v, enable, ...row } = data[0];
      const rows = Object.keys(row);
      rows.forEach((key) =>
        tmpColumns.push({
          key: key,
          title: key,
          dataIndex: key,
          className: "whitespace-nowrap",
          ...getColumnSearchProps(key),
          sorter: (a, b) => +(a[key] > b[key]) || -(a[key] < b[key]),
          sortDirections: ["descend", "ascend"],
        })
      );
      setColumns([
        ...tmpColumns,
        {
          key: "",
          title: "enable",
          dataIndex: "",
          className: "whitespace-nowrap",
          render: (value, record) => (
            <div className="flex items-center">
              <UpdateAlert
                item={record}
                id={record._id}
                updateDataSource={fetcher}
              />
            </div>
          ),
        },
        {
          key: "",
          title: "",
          dataIndex: "",
          className: "whitespace-nowrap",
          render: (value, record) => (
            <div className="flex items-center justify-end">
              <DeleteAlert id={record._id} updateDataSource={fetcher} />
              <CreateAlert editMode data={record} updateDataSource={fetcher} />
            </div>
          ),
        },
      ]);
    } catch (error) {
      message.error("Action has error",20);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetcher();
  }, []);

  function getColumnSearchProps(dataIndex) {
    return {
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={(node) => {
              search.searchInput = node;
            }}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button
              onClick={() => handleReset(clearFilters)}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                confirm({ closeDropdown: false });
                setSearch({
                  searchText: selectedKeys[0],
                  searchedColumn: dataIndex,
                });
              }}
            >
              Filter
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record[dataIndex]
          ? record[dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          : "",
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          setTimeout(() => search.searchInput.select(), 100);
        }
      },
      render: (text) =>
        search.searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[search.searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    };
  }

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearch({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearch({ searchText: "" });
  };

  const handleChange = (pagination, filters, sorter, { currentDataSource }) => {
    setFiltredDataSet(currentDataSource);
  };

  return (
    <div className="p-5 space-y-5">
      <CreateAlert updateDataSource={fetcher} />

      <Table
        scroll={{ scrollToFirstRowOnChange: true, x: "480px" }}
        onChange={handleChange}
        dataSource={[...filtredDataSet]}
        loading={loading}
        columns={[...columns]}
        rowKey="_id"
      />
    </div>
  );
};

export default Alert;
